export default __webpack_public_path__ + "img/chardonnay-millesime.asset.c5d6ba8c.png";